// Helpers for gating UI by an actor's effective access level on an
// object. The level is resolved by the backend
// (Workflow.viewerAccessLevel / Issue.viewerAccessLevel) and reflects
// the full priority chain (Owner / role / direct share / team share /
// creator / public default). Capabilities come straight from
// ACCESS_LEVEL_CAPS in @salestrak/permissions — the same matrix the
// backend enforces — so the UI can't drift from what mutations allow.

import {
  accessLevelAllows,
  type ObjectAccessLevel,
} from "@salestrak/permissions";

export type AccessLevel = ObjectAccessLevel;

export function canView(level: AccessLevel | null | undefined): boolean {
  return level != null && accessLevelAllows(level, "view");
}

// `comment` and above can post notes. `view` cannot.
export function canComment(level: AccessLevel | null | undefined): boolean {
  return level != null && accessLevelAllows(level, "comment");
}

// `edit` and `full_edit` can edit issue fields. (Edit implies comment.)
export function canEdit(level: AccessLevel | null | undefined): boolean {
  return level != null && accessLevelAllows(level, "edit");
}

// Only `full_edit` can manage sharing / delete the object — the only
// tier the caps matrix grants `delete`.
export function canManageSharing(
  level: AccessLevel | null | undefined,
): boolean {
  return level != null && accessLevelAllows(level, "delete");
}
